/**
 * @generated SignedSource<<6638acaa78ee1b212cb7909a2a0ef269>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutPaymentReducer_preCheckoutTransaction$data = {
  readonly paymentAuthorizations: ReadonlyArray<{
    readonly paymentMethod: {
      readonly billingAddress?: {
        readonly " $fragmentSpreads": FragmentRefs<"checkoutForms_address">;
      } | null;
    } | null;
    readonly status: string | null;
  } | null> | null;
  readonly " $fragmentType": "checkoutPaymentReducer_preCheckoutTransaction";
};
export type checkoutPaymentReducer_preCheckoutTransaction$key = {
  readonly " $data"?: checkoutPaymentReducer_preCheckoutTransaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutPaymentReducer_preCheckoutTransaction">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutPaymentReducer_preCheckoutTransaction"
};

(node as any).hash = "510a29af73eb7502d96e9b6d0bef6ebc";

export default node;
